import { render } from "./FramesSection.vue?vue&type=template&id=20d3cb15&scoped=true"
import script from "./FramesSection.vue?vue&type=script&lang=js"
export * from "./FramesSection.vue?vue&type=script&lang=js"

import "./FramesSection.vue?vue&type=style&index=0&id=20d3cb15&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d3cb15"]])

export default __exports__